export class Emitter {
  #listeners = new Map();

  on(type, callback) {
    const listeners = this.#listeners.get(type) || new Set();
    listeners.add(callback);
    this.#listeners.set(type, listeners);
    return () => listeners.delete(callback);
  }

  emit(type, detail) {
    const listeners = this.#listeners.get(type);
    if (!listeners) return;
    listeners.forEach((callback) => callback(detail));
  }
}
